import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const MARCH_COMPETITION_END_DATE = d(2024, 4, 2, 10, 0);
